// Medya dosyası türünü belirlemek için utility fonksiyonları

/**
 * Dosya uzantısından medya türünü belirler
 * @param {string} filename - Dosya adı veya URL
 * @returns {string} - 'image', 'video' veya 'unknown'
 */
export const getMediaType = (filename) => {
  if (!filename) return 'unknown';
  
  const extension = filename.toLowerCase().split('.').pop();
  
  const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp', 'ico'];
  const videoExtensions = ['mp4', 'webm', 'ogg', 'avi', 'mov', 'wmv', 'flv', '3gp', 'mkv'];
  
  if (imageExtensions.includes(extension)) {
    return 'image';
  } else if (videoExtensions.includes(extension)) {
    return 'video';
  }
  
  return 'unknown';
};

/**
 * Medya dosyasının resim olup olmadığını kontrol eder
 * @param {string} filename - Dosya adı veya URL
 * @returns {boolean}
 */
export const isImage = (filename) => {
  return getMediaType(filename) === 'image';
};

/**
 * Medya dosyasının video olup olmadığını kontrol eder
 * @param {string} filename - Dosya adı veya URL
 * @returns {boolean}
 */
export const isVideo = (filename) => {
  return getMediaType(filename) === 'video';
};

/**
 * Medya URL'sinden dosya uzantısını alır
 * @param {string} url - Medya URL'si
 * @returns {string} - Dosya uzantısı
 */
export const getFileExtension = (url) => {
  if (!url) return '';
  return url.toLowerCase().split('.').pop().split('?')[0];
};

/**
 * Video için desteklenen formatları kontrol eder
 * @param {string} filename - Dosya adı veya URL
 * @returns {boolean}
 */
export const isSupportedVideoFormat = (filename) => {
  const extension = getFileExtension(filename);
  const supportedFormats = ['mp4', 'webm', 'ogg'];
  return supportedFormats.includes(extension);
};

/**
 * Resim için desteklenen formatları kontrol eder
 * @param {string} filename - Dosya adı veya URL
 * @returns {boolean}
 */
export const isSupportedImageFormat = (filename) => {
  const extension = getFileExtension(filename);
  const supportedFormats = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg'];
  return supportedFormats.includes(extension);
};

/**
 * Medya dosyası için uygun MIME type döndürür
 * @param {string} filename - Dosya adı veya URL
 * @returns {string} - MIME type
 */
export const getMimeType = (filename) => {
  const extension = getFileExtension(filename);
  
  const mimeTypes = {
    // Images
    'jpg': 'image/jpeg',
    'jpeg': 'image/jpeg',
    'png': 'image/png',
    'gif': 'image/gif',
    'webp': 'image/webp',
    'svg': 'image/svg+xml',
    'bmp': 'image/bmp',
    'ico': 'image/x-icon',
    
    // Videos
    'mp4': 'video/mp4',
    'webm': 'video/webm',
    'ogg': 'video/ogg',
    'avi': 'video/x-msvideo',
    'mov': 'video/quicktime',
    'wmv': 'video/x-ms-wmv',
    'flv': 'video/x-flv',
    '3gp': 'video/3gpp',
    'mkv': 'video/x-matroska'
  };
  
  return mimeTypes[extension] || 'application/octet-stream';
};

const mediaUtils = {
  getMediaType,
  isImage,
  isVideo,
  getFileExtension,
  isSupportedVideoFormat,
  isSupportedImageFormat,
  getMimeType
};

export default mediaUtils;
